export const systemSettingsNamesMapping: any = {
	'digital-balance': 'הפקדה דיגיטלית',
	'max-amount-to-digital-deposit': 'סכום מקסימלי להפקדה דיגיטלית',
	'digital-balance-feature-enabled': 'הפקדה דיגיטלית - זמין/לא זמין ללקוחות',
	'whatsapp-button-enabled': 'WhatsApp צ׳אט',
};

const BALANCES_SUBTITLE =
	'במסך זה תוכל לנהל את כל ההגדרות הקשורות לפיצ’ר של הוספת יתרה דיגיטלית, לרבות מגבלות סכום, תנאי הפעלה, הרשאות משתמשים, ותצורות ברירת מחדל.';
const BALANCES_WARNING =
	'⚠️ שימו לב: השדות בטאב זה רגישים במיוחד, וכל שינוי בהם משפיע ישירות על אופן פעולת הפיצ’ר במערכת החיה. מומלץ לערוך שינויים בזהירות ורק לאחר הבנה מלאה של המשמעות התפעולית.';
const FEATURE_FLAGS_SUBTITLE =
	'במסך זה ניתן לנהל את דגלי הפיצ’רים (Feature Flags) של המערכת – לאפשר, להשבית או לקבוע תנאים להפעלה של יכולות שונות, מבלי לפרוס גרסה חדשה. ניהול נכון של הדגלים מאפשר שליטה הדרגתית, בדיקות A/B והפעלת פיצ’רים לפי משתמשים, תאריכים או תצורות שונות.';
const FEATURE_FLAGS_WARNING =
	'⚠️ שימו לב: שדות אלו משפיעים באופן ישיר על זמינות פיצ’רים במערכת החיה. שינוי לא זהיר עלול לגרום להשבתת יכולות או לחשיפת פיצ’רים לא מוכנים. יש לפעול בזהירות ולבצע בדיקות מקדימות ככל הניתן.';

export const systemSettingsTypes = {
	FEATURE_FLAGS: 'feature_flags',
	GENERAL_SETTINGS_BALANCES: 'balance',
};

export const systemSettingsSubtitlesMapping: any = {
	[systemSettingsTypes.FEATURE_FLAGS]: {
		subtitle: FEATURE_FLAGS_SUBTITLE,
		warning: FEATURE_FLAGS_WARNING,
	},
	[systemSettingsTypes.GENERAL_SETTINGS_BALANCES]: {
		subtitle: BALANCES_SUBTITLE,
		warning: BALANCES_WARNING,
	},
};
